import { ACCESS_TOKEN_KEY } from '../constants/commonConstant';

const logout = () => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
};

export default logout;
